<app-header></app-header>

<div class="app-body">
  <app-sidebar></app-sidebar>
  <div class="main">
    <router-outlet></router-outlet>
  </div>
</div>

